module.exports = __webpack_public_path__ + "img/start-btn.a69ae2b0.png";